export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/sales-invoice-online-pay/:pageId',
        component: () => import('@/views/page/company/core-accounting/inventory/sales/OnlineMoneyReceipt.vue'),
        name: 'sales-invoice-online-pay',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/payment-status/:pageId',
        component: () => import('@/views/page/company/core-accounting/inventory/sales/PaymentStatus.vue'),
        name: 'payment-status',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-payments/:pageId',
        component: () => import('@/views/page/company/core-accounting/inventory/sales/my-payments/List.vue'),
        name: 'my-payments',
        meta: {
            requiresAuth: true
        }
    }
]
